import React, { useState, useEffect } from "react";
import { Button, TextArea, Icon } from "semantic-ui-react";
import { connect, useDispatch } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import "./AddNewSeo.css";
import { addSeo } from "../store/actions/athleteActions";
import { BsFillPatchCheckFill } from "react-icons/bs";
import ReactTagInput from "@pathofdev/react-tag-input";
import "@pathofdev/react-tag-input/build/index.css";
const AddNewSeo = (props) => {
  const [changesMade, setChangesMade] = useState(false);
  const [error, setError] = useState(null);
  const [tags, setTags] = useState([]);
  const [desc, setDesc] = useState(null);
  const [addedSport, setAddedSport] = useState(false);
  useEffect(() => {
    if (props.seo) {
      if (props.seo[props.athleteUid]) {
        setTags([...props.seo[props.athleteUid].tags]);
        setDesc(props.seo[props.athleteUid].description);
      }
    }
  }, [props.seo, props.athleteUid]);
  const dispatch = useDispatch();
  const executeState = () => {
    setAddedSport(true);
    props.close();
  };
  const newSeoAddHandler = (e) => {
    e.preventDefault();
    if (tags.length < 1 || !desc) {
      setError("All fields required");
    } else {
      const myPromise = new Promise((resolve, reject) => {
        dispatch(addSeo(tags, desc, props.athleteUid));
      });
      myPromise.then(setTimeout(executeState(), 6500));
    }
  };

  const handleDescriptionChange = (description) => {
    if (description) {
      setDesc(description);
      setChangesMade(true);
    } else {
      setError("All fields are required");
      setChangesMade(false);
    }
  };

  return (
    <div className="seo-modal-body">
      <div className="AdminTopButtonsDropzoneContainer">
        <div className="AdminTopButtonsContainer ">
          <Button floated="left" circular icon="close" onClick={props.close} />
          <Button
            floated="right"
            icon="checkmark"
            positive
            disabled={!error && !changesMade}
            content="Save"
            labelPosition="left"
            onClick={newSeoAddHandler}
          />
        </div>
      </div>
      <h3 className="cu-center">SEO Of {props.athleteName}</h3>
      <div>
        <div className="form-group">
          <label>Tags</label>
          <ReactTagInput
            tags={tags}
            onChange={(newTags) => {
              if (newTags.length > 0) {
                setTags(newTags);
                setChangesMade(true);
              } else setChangesMade(false);
            }}
          />
        </div>
        <div className="cu-input form-group mb-0">
          <label>Description</label>
          <TextArea
            className="cu-textarea"
            placeholder="SEO Description"
            defaultValue={desc}
            rows={6}
            onChange={(e) => handleDescriptionChange(e.target.value)}
          />
          {error && <p className="error-msg">{error}</p>}
        </div>

        {addedSport && (
          <span className="success">
            Added <BsFillPatchCheckFill size={16} />
          </span>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    seo: state.firestore.data.testSEO,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect(() => [
    {
      collection: "testSEO",
    },
  ])
)(AddNewSeo);
